interface Configuration {
	origin: string;
	getAccessToken?: () => Promise<string>;
}

const configuration: Configuration = {
	origin: `${window.origin}/io/auditcollectorservice/v1`,
};

export function configureAuditCollectorHttp(
	configure: (current: Configuration) => void
): void {
	configure(configuration);
}
async function createRequest(path: string, init: RequestInit = {}): Promise<Request> {
	init.headers = { ...init.headers, 'X-BFF-CSRF': 'true' };
	if (!(path.startsWith('http') || path.startsWith('//')) && configuration.origin) {
		const normalizedBase = configuration.origin.endsWith('/')
			? configuration.origin.slice(0, -1)
			: configuration.origin;
		const normalizedPath = path.startsWith('/') ? path : `/${path}`;
		path = `${normalizedBase}${normalizedPath}`;
	}

	return new Request(path, init);
}

async function handleResponse<T>(response: Response): Promise<T> {
	if (!response.ok) {
		const errorText = await response.text();
		throw new Error(errorText || 'Request failed');
	}
	const data = await response.json();
	return data as T;
}

interface ReportResponse {
	id: string;
	fileName: string;
	status: string;
}

export const AuditCollectorHttp = {
	async postV1ReportsGenerate(
		reportName: string,
		startDateUtc: string,
		endDateUtc: string,
		containerRID: string,
		subjectRID: string,
		timeZoneUtcOffset: string,
		includeSubjectDescendents = true
	): Promise<ReportResponse> {
		const requestBody = {
			reportName,
			startDateUtc,
			endDateUtc,
			containerRID,
			subjectRID,
			timeZoneUtcOffset,
			includeSubjectDescendents,
		};

		const request = await createRequest('/reports/generate', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(requestBody),
		});

		const response = await fetch(request);
		return handleResponse<ReportResponse>(response);
	},

	async GetReportById(reportId: string): Promise<ReportResponse> {
		const request = await createRequest(`/reports/${reportId}`, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json' },
		});

		const response = await fetch(request);
		return handleResponse<ReportResponse>(response);
	},

	async GetReportByIDDownload(reportId: string): Promise<void> {
		const request = await createRequest(`/reports/${reportId}/download`, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json' },
		});

		const response = await fetch(request);
		if (!response.ok) {
			throw new Error('Could not download report data');
		}

		const blob = await response.blob();
		let filename = 'report_default.csv';

		const contentDisposition = response.headers.get('Content-Disposition');
		if (contentDisposition) {
			const match = contentDisposition.match(/filename="?(.+?)"?(;|$)/);
			if (match) {
				filename = match[1];
			}
		}

		const link = document.createElement('a');
		link.href = window.URL.createObjectURL(blob);
		link.download = filename;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	},
};
